import styles from './devicesSideBar.jcss'
import React, { useState } from 'react'
import { Button } from '../../../molecules/Button'
import translate from '../../../core/translate'
import { cn } from 'ethcss'
import { Typography } from 'atoms/Typography'
import Modal from '../../../blocks.simple/modal/modal'
import { DeviceModalContent } from '../__deviceModalContent/DeviceModalContent'
import { DeviceModalSaveData, IDevicesSidebarProps, isAdvertisementDeviceStatus } from '../externalAdvertisement.types'
import { api } from '../../../core/api/ConnectionManager'
import { RootStateOrAny, useSelector } from 'react-redux'

export const DevicesSidebar: React.FC<IDevicesSidebarProps> = ({ selected, selectedTab, selectedItems, onCancel }) => {
    const [open, setOpen] = useState(false)
    const tokens: any = useSelector<RootStateOrAny>((state) => state.user.tokens)

    const onSave = async (data: DeviceModalSaveData) => {
        if (selectedTab === 'devices' && data instanceof FormData) {
            try {
                api.post('doohDspDeviceSettings', data, {
                    Authorization: `Bearer ${tokens.accessToken}`,
                })
                    .then((res) => {
                        console.log(res)

                        setOpen(false)
                    })
                    .catch((e) => console.log(e))
            } catch (e) {
                console.log(e)
            }

            return
        }

        if (selectedTab === 'advertisementDevices' && isAdvertisementDeviceStatus(data)) {
            api.send('doohUpdateSettingsEnabled', {
                digitalSignageId: data.digitalSignageId,
                groupId: data.groupId,
                enabled: data.status,
            }).then(() => setOpen(false))
        }
    }

    const selectedDevice = selectedItems[0] || selected

    return (
        <div className={styles.wrapper}>
            {selectedDevice ? (
                <>
                    <div>
                        <div className={styles.captionWrapper}>
                            <Typography className={cn(styles.caption)}>
                                {selectedItems.length
                                    ? translate('selected')
                                    : translate(selectedDevice.type === 'group' ? 'group' : 'device')}
                            </Typography>
                            <div className={styles.deviceName}>
                                {selectedItems.length > 1 ? selectedItems.length : selectedDevice.name}
                            </div>
                        </div>
                        <div>
                            <Button size={'s'} className={styles.editButton} onClick={() => setOpen(true)}>
                                {translate('edit')}
                            </Button>
                        </div>
                        <div className={styles.cancelButtonWrapper}>
                            <Button size={'s'} className={styles.cancelButton} onClick={onCancel}>
                                {translate('deselect')}
                            </Button>
                        </div>
                    </div>
                    <Modal open={open} mod={'black'} showCloseIcon={false}>
                        <DeviceModalContent
                            onClose={() => setOpen(false)}
                            onSave={onSave}
                            selected={selectedDevice}
                            selectedTab={selectedTab}
                            selectedItems={selectedItems}
                        />
                    </Modal>
                </>
            ) : (
                <div className={styles.unselected}>{translate('advertisementDevicesUnselectedTip')}</div>
            )}
        </div>
    )
}
